import React from "react";
import clsx from "clsx";
import loadable from "@loadable/component";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

import styles from "./ContactItem.styles";

const ReactSVGIcon = loadable(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));

const ContactItem = ({ button, title, phone, phoneLink, mail, url }) => {
	const { REACT_APP_PATH } = process.env;
	const css = styles();

	return (
		<Box className={clsx(css.root, "extension-contact-item")}>
			<div className={css.content}>
				{title && (
					<Typography
						className={css.title}
						color="textSecondary"
						dangerouslySetInnerHTML={{ __html: title }}
						variant="overline"
						component="p"
					/>
				)}
				{phone && (
					<Typography className={css.phone} variant="subtitle1" component="div">
						<a href={"tel:" + phoneLink?.replace(/ /g, "")}>
							<ReactSVGIcon src="/img/icons/phone.svg" size={24} />
							<span>{phone}</span>
						</a>
					</Typography>
				)}
				{mail && (
					<Typography className={css.mail} variant="subtitle1" component="div">
						<a href={"mailto:" + mail}>
							<ReactSVGIcon src="/img/icons/mail.svg" size={24} />
							<span>{mail}</span>
						</a>
					</Typography>
				)}
				{button && url && (
					<a
						className={clsx(css.button, "extension-contact-item__button")}
						href={url.includes("http") ? url : REACT_APP_PATH + url}
						target="_blank"
						rel="noreferrer"
					>
						<Button color="primary" variant="contained">
							{button}
						</Button>
					</a>
				)}
			</div>
		</Box>
	);
};

export default ContactItem;
